import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/home/ubuntu/download/6998fb9ef782d50014d47ea7/petfob/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download/6998fb9ef782d50014d47ea7/petfob/src/app/homepage/components/BusinessBenefitsSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download/6998fb9ef782d50014d47ea7/petfob/src/app/homepage/components/HeroSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download/6998fb9ef782d50014d47ea7/petfob/src/app/homepage/components/HomepageCTA.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download/6998fb9ef782d50014d47ea7/petfob/src/app/homepage/components/HowItWorksSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download/6998fb9ef782d50014d47ea7/petfob/src/app/homepage/components/OwnerBenefitsSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download/6998fb9ef782d50014d47ea7/petfob/src/app/homepage/components/TestimonialsSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download/6998fb9ef782d50014d47ea7/petfob/src/components/Header.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download/6998fb9ef782d50014d47ea7/petfob/src/components/ui/AppIcon.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download/6998fb9ef782d50014d47ea7/petfob/src/components/ui/AppLogo.tsx");
